import device from '@/utils/device';
import { TLang } from './lang';
/**
 *
 *
 */
function parseDate(t: string = '') {
  if (!t) {
    return {};
  }
  let date;
  if (device.isSafari() || device.isIOS()) {
    date = new Date(t.replace(/-/g, '/'));
  } else {
    date = new Date(t);
  }

  let time = {
    year: date.getFullYear(),
    month: ('0' + (date.getMonth() + 1)).slice(-2),
    day: ('0' + date.getDate()).slice(-2),
    week: 'w' + date.getDay(),
    dis: daysDistance(
      `${date.getFullYear()}-${('0' + (date.getMonth() + 1)).slice(-2)}-${(
        '0' + date.getDate()
      ).slice(-2)}`,
    ) //date
  };

  const l = (time.dis < 3 ? time.dis : time.week) + '';
  return {
    origin: t,
    date: time.month && time.day ? `${time.month}-${time.day}` : '',
    label: getText(l)
  };
}
function getText(d) {
  let text = '';
  switch (d) {
  case '0':
    text = TLang('今天', 'home', false, false, null);
    break;
  case '1':
    text = TLang('明天', 'home', false, false, null);
    break;
  case '2':
    text = TLang('后天', 'home', false, false, null);
    break;
  case 'w0':
    text = TLang('周日', 'home', false, false, null);
    break;
  case 'w1':
    text = TLang('周一', 'home', false, false, null);
    break;
  case 'w2':
    text = TLang('周二', 'home', false, false, null);
    break;
  case 'w3':
    text = TLang('周三', 'home', false, false, null);
    break;
  case 'w4':
    text = TLang('周四', 'home', false, false, null);
    break;
  case 'w5':
    text = TLang('周五', 'home', false, false, null);
    break;
  case 'w6':
    text = TLang('周六', 'home', false, false, null);
    break;
  default:
    text = '';
  }
  return text;
}

function daysDistance(t) {
  //parse() 是 Date 的一个静态方法 , 所以应该使用 Date.parse() 来调用，而不是作为 Date 的实例方法。返回该日期距离 1970/1/1 午夜时间的毫秒数
  // let date1 = new Date().getTime()
  let d = new Date();
  let date1 = Date.parse(
    `${d.getFullYear()}-${('0' + (d.getMonth() + 1)).slice(-2)}-${('0' + d.getDate()).slice(-2)}`,
  );
  let date2 = Date.parse(t);
  //计算两个日期之间相差的毫秒数的绝对值
  var ms = date2 - date1;
  //毫秒数除以一天的毫秒数,就得到了天数
  var days = Math.floor(ms / (24 * 3600 * 1000));
  return days < 0 ? -1 : days;
}
function timeToHm(d) {
  return d.match(/(\d)+:(\d){0,2}/)[0];
}
function timeAdd(d, t) {
  if (!d || !t) {
    return '';
  }
  const time: string = d.match(/(\d)+:(\d){0,2}/)[0];
  let h = parseInt(time.split(':')[0]);
  let s = parseInt(time.split(':')[1]);

  let ss = s + t;
  let hour = h + Math.floor(ss / 60);
  let minte = (ss % 60) + '';
  if (hour >= 24) {
    hour = hour - 24;
  }
  return `${('0' + hour).slice(-2)}:${('0' + minte).slice(-2)}`;
}

/**
 *  true 大于（现在/距离现在)的时间，去掉过期时间
    dis存在 true 大于现在X分钟
 */
const greaterThanNow = (d, dis?): boolean => {
  // 后面兼容ios
  let date1 = Date.parse(d);
  if (device.isIOS()) {
    date1 = Date.parse(d.replace(/-/g, '/'));
  }
  let now = new Date().getTime();
  //计算两个日期之间相差的毫秒数的绝对值
  var ms = date1 - now;

  if (typeof dis === 'undefined') {
    return ms > 0 ? true : false;
  } else if (dis) {
    var mi = Math.ceil(ms / (60 * 1000));
    return mi > dis ? true : false;
  }
  return false;
};

/**
 *  距离现在多久，ege: 15分钟30秒
 */
const distanceNow = (d): string => {
  if (!d) {
    return '';
  }
  // 后面兼容ios
  let date1 = Date.parse(d) || Date.parse(new Date(d.replace(/-/g, '/')));
  let now = new Date().getTime();
  //计算两个日期之间相差的毫秒数的绝对值
  var ms = date1 - now;
  if (ms <= 0) {
    return '';
  }

  var s = ms / 1000; // 秒
  var hh = Math.floor(s / 3600); // 小时
  var mm = 0;
  var ss = 0;
  if (hh > 0) {
    s = s - 3600 * hh;
    mm = Math.floor(s / 60); // 分钟
    ss = Math.floor(s % 60); // 秒
    return `${hh}${TLang('小时', 'home', false, false, null)}${mm}${TLang('分', 'home', false, false, null)}${ss}${TLang('秒', 'home', false, false, null)}`;
  } else {
    mm = Math.floor(s / 60); // 分钟
    ss = Math.floor(s % 60); // 秒
    return `${mm}${TLang('分', 'home', false, false, null)}${ss}${TLang('秒', 'home', false, false, null)}`;
  }
};

/**
 * 根据 影片信息，返回影片信息，例如 今天09月01日 16：00-18：00 国语3D
 */
const getMovieSessionInfoStr = (movie) => {
  if (!movie.showDateTime) {
    return '';
  }
  let t = parseDate(movie.showDateTime);
  let t2 = timeAdd(movie.showDateTime, movie.duration);
  let day: Array<string> = t.date.split('-');
  let t3 = timeToHm(movie.showDateTime);
  return `${t.label}${day[0]}${TLang('月', 'home', false, false, null)}${day[1]}${TLang('日', 'home', false, false, null)} ${t3}-${t2} ${movie.language || ''}${movie.dimensional ||
    ''}`;
};

/**
 * 根据 影片信息，返回影片信息，例如 今天09月01日 16：00-18：00 国语3D
 */
const getMovieSessionInfoTimeStr = (movie) => {
  if (!movie?.showDateTime) {
    return '';
  }
  let t = parseDate(movie.showDateTime);
  let t2 = timeAdd(movie.showDateTime, movie.duration);
  let day: Array<string> = t.date.split('-');
  let t3 = timeToHm(movie.showDateTime);
  return `${t.label}${day[0]}${TLang('月', 'home', false, false, null)}${day[1]}${TLang('日', 'home', false, false, null)} ${t3}-${t2}`;
};

/**
 * 判断放映时间是否晚于今天
 */
const getReleaseDate = (date) => {
  let flag = false;
  if (date) {
    let d = new Date(Date.parse(date.toString().replace(/-/g, '/')));
    const curDate = new Date();
    if(d <= curDate){
      flag =  false;
    }else{
      flag =  true;
    }
  }
  return flag;
};

export {
  parseDate,
  daysDistance,
  timeToHm,
  timeAdd,
  greaterThanNow,
  getMovieSessionInfoStr,
  getMovieSessionInfoTimeStr,
  distanceNow,
  getReleaseDate
};
